module.exports = __webpack_public_path__ + "img/news-default.6527c221.png";